export const PAGINATION_PAGE_SIZE_DEFAULT = 50;
export const PAGINATION_PAGE_SIZE_LARGE = 100;
export const PAGINATION_PAGE_SIZE_DEFAULT_STRABAG = PAGINATION_PAGE_SIZE_LARGE;

export const PAGINATION_SORT_DIRECTION = ['ASC', 'DESC'] as const;

export type PaginationSortDirection =
  (typeof PAGINATION_SORT_DIRECTION)[number];
